
import { Card, Divider, Grid, Icon } from "@mui/material";
import PropTypes from "prop-types";

import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import theme from "assets/theme";
import moment from "moment";
import EventsBarPreviewCard from "../EventsBarPreviewCard";
import { useSoftUIController } from "context";

const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
const { dark, white, text, transparent } = palette;
const { navbarBoxShadow } = boxShadows;
const { rgba, pxToRem } = functions;
const { borderRadius } = borders;

function wrapper(events_length, sidebarState, deviceStyle, content) {
    if (events_length > 0) {
        return (
            <SoftBox p={2} pb={1.5} mx={sidebarState == 'exploring' && deviceStyle == 'mobile' ? 2 : 0}
                sx={({ palette: { white }, breakpoints, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                    boxShadow: navbarBoxShadow,
                    backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                    backgroundColor: rgba(white.main, 0.8),
                    borderRadius: borderRadius.xl,
                    height: 'auto',
                    overflow: 'auto',
                    pointerEvents: 'auto'
                })}
            >
                {content}
            </SoftBox>
        )
    }
    else {
        if (deviceStyle == 'mobile') {
            return (
                <SoftBox p={2} mx={sidebarState == 'exploring' ? 2 : 0}
                    sx={({ palette: { white }, breakpoints, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                        boxShadow: navbarBoxShadow,
                        backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                        backgroundColor: rgba(white.main, 0.8),
                        borderRadius: borderRadius.xl,
                        height: 'calc(100% - 36px)',
                        width: '100%',
                        overflow: 'auto',
                        pointerEvents: 'auto',
                    })}
                >
                    {content}
                </SoftBox>
            )
        }
        else {
            return (
                <Grid container sx={{ height: '100%' }}>
                    <Grid item xxs={12} xl={5} xxl={5} x3l={5} x4l={4} /*display={'inline-flex'} flexDirection={'row'} alignItems={'flex-start'}*/>
                        <Grid container sx={{ height: '100%', maxWidth: pxToRem(860) }}>
                            <Grid item xxs={12} xl={11}>
                                <SoftBox p={2} pb={1.5} mx={sidebarState == 'exploring' ? 2 : 0}
                                    sx={({ palette: { white }, breakpoints, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                                        boxShadow: navbarBoxShadow,
                                        backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                                        backgroundColor: rgba(white.main, 0.8),
                                        borderRadius: borderRadius.xl,
                                        height: 'calc(100% - 28px)',
                                        overflow: 'auto',
                                        pointerEvents: 'auto',
                                    })}
                                >
                                    {content}
                                </SoftBox>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }
    }
}

function EventsBar({ events_data, eventbarState, setEventbarState, sidebarState }) { // LAYER 4

    const [controller, dispatch] = useSoftUIController();
    const { deviceStyle, miniNavbar } = controller;

    useEffect(() => {
        setEventbarState(events_data.length > 0 ? "open" : "closed");
    }, [eventbarState]);

    var now = moment().unix();

    var events_data_filtered = [];
    for (var event of events_data) {
        var groups_filtered = event.groups.filter((row) => row.type == 'clearways' || typeof row.type == 'undefined');
        if (groups_filtered.length) {
            events_data_filtered.push(event);
        }
    }

    events_data = events_data_filtered.filter(event => moment(event.display_time).unix() <= moment().add(7, 'days').unix());

    const renderPreviewCards = events_data.sort((a, b) => {
        var a_val = 1;
        var b_val = 1;

        if (moment(a.end_time).unix() > now && moment(a.start_time) < now) {
            a_val = 3;
        }
        else if (moment(a.start_time).unix() > now && moment(a.display_time) < now) {
            a_val = 2;
        }

        if (moment(b.end_time).unix() > now && moment(b.start_time) < now) {
            b_val = 3;
        }
        else if (moment(b.start_time).unix() > now && moment(b.display_time) < now) {
            b_val = 2;
        }

        if (a_val > b_val) {
            return -1;
        }
        else if (a_val < b_val) {
            return 1;
        }
        else {
            if (a_val == 3) {
                return moment(a.end_time).unix() - moment(b.end_time).unix()
            }
            else if (a_val == 2) {
                return moment(a.start_time).unix() - moment(b.start_time).unix()
            }
            else {
                return moment(a.display_time).unix() - moment(b.display_time).unix()
            }
        }
    }).map(function (event, index) {
        if (sidebarState == 'exploring' && deviceStyle == 'mobile') {
            return (
                <Grid item key={index} xxs={12} md={6} mb={2}>
                    <EventsBarPreviewCard event={event} sidebarState={sidebarState} deviceStyle={deviceStyle} miniNavbar={miniNavbar} />
                </Grid>
            )
        }
        else {
            return (<EventsBarPreviewCard key={index} event={event} sidebarState={sidebarState} deviceStyle={deviceStyle} miniNavbar={miniNavbar} />)
        }
    });

    return (
        wrapper(events_data.length, sidebarState, deviceStyle,
            (<SoftBox sx={{
                // overflow: "auto",
                height: '100%',

                '::-webkit-scrollbar': {
                    backgroundColor: 'transparent',
                    height: '8px',
                    width: '6px',
                },
                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                    backgroundColor: 'transparent',
                },
                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                    backgroundColor: '#babac0',
                    borderRadius: '6px',
                    // border: `1px solid ${rgba(white.main, 0.8)}`,
                },
                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                    display: 'none',
                },
            }}>
                {(sidebarState == 'exploring' && deviceStyle == 'mobile') ? (
                    <>
                        {/* <SoftBox sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            {window.innerWidth < breakpoints.values.xs && (
                                <SoftTypography variant='h6'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                            {(window.innerWidth >= breakpoints.values.xs && window.innerWidth < breakpoints.values.sm) && (
                                <SoftTypography variant='h5'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                            {window.innerWidth >= breakpoints.values.sm && (
                                <SoftTypography variant='h4'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                        </SoftBox> */}
                        {events_data.length > 0 ? (
                            <SoftBox p={2} display='flex' flexDirection='row' sx={{
                                height: 'fit-content',
                                overflow: 'auto',

                                '::-webkit-scrollbar': {
                                    backgroundColor: 'transparent',
                                    height: '8px',
                                    width: '6px',
                                },
                                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                                    backgroundColor: 'transparent',
                                },
                                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                                    backgroundColor: '#babac0',
                                    borderRadius: '6px',
                                    // border: `1px solid ${rgba(white.main, 0.8)}`,
                                },
                                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                                    display: 'none',
                                },
                            }}>
                                <Grid container spacing={3}>
                                    {renderPreviewCards}
                                </Grid>
                            </SoftBox>
                        ) : (
                            <SoftBox display='flex' flexDirection='row' justifyContent='center' alignItems='center' sx={{ paddingTop: '8%' }}>
                                <SoftTypography variant='h6'>
                                    No Events To Show!
                                </SoftTypography>
                            </SoftBox>
                        )}
                    </>
                ) : (
                    <>
                        {/* <SoftBox pl={{ xxs: 0, sm: 1 }} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: { xxs: 'center', sm: 'flex-start' } }}>
                            {window.innerWidth < breakpoints.values.xs && (
                                <SoftTypography variant='h6'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                            {(window.innerWidth >= breakpoints.values.xs && window.innerWidth < breakpoints.values.sm) && (
                                <SoftTypography variant='h5'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                            {window.innerWidth >= breakpoints.values.sm && (
                                <SoftTypography variant='h4'>
                                    Upcoming Events This Week
                                </SoftTypography>
                            )}
                        </SoftBox> */}
                        {events_data.length > 0 ? (
                            <SoftBox pt={2} pr={1.5} display='flex' flexDirection='row' sx={{
                                height: deviceStyle == 'desktop' ? 'calc(100% - 86px)' : 'calc(100% - 66px)',
                                overflow: 'auto',

                                '::-webkit-scrollbar': {
                                    backgroundColor: 'transparent',
                                    height: '8px',
                                    width: '6px',
                                },
                                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                                    backgroundColor: 'transparent',
                                },
                                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                                    backgroundColor: '#babac0',
                                    borderRadius: '6px',
                                    // border: `1px solid ${rgba(white.main, 0.8)}`,
                                },
                                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                                    display: 'none',
                                },
                            }}>
                                {renderPreviewCards}
                            </SoftBox>
                        ) : (
                            <SoftBox display='flex' flexDirection='row' justifyContent='center' alignItems='center' sx={{ paddingTop: '8%' }}>
                                <SoftTypography variant='h6'>
                                    No Events To Show!
                                </SoftTypography>
                            </SoftBox>
                        )}
                    </>
                )}
            </SoftBox >)
        )
    );
}

EventsBar.propTypes = {
    events_data: PropTypes.array,
    eventbarState: PropTypes.string,
    setEventbarState: PropTypes.func,
    sidebarState: PropTypes.string,
}

export default EventsBar;
